import { IReceiversOverviewStateService } from "./i-receivers-overview-state.service";
import { IReceiver } from "../../models/i-receiver";
import { AOverviewStateService } from "@zaeper/angular-dashboard-view-lib";

export class ReceiversOverviewStateService extends AOverviewStateService<IReceiver> implements IReceiversOverviewStateService {
}
